import axios from 'axios';

// Dashboard je na srpskom: bek bira jezik poruka po Accept-Language zaglavlju,
// pa ga saljemo eksplicitno (inace browser salje svoj jezik, npr. engleski).
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept-Language': 'sr',
};

export const publicClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  timeout: 100000,
  headers: { ...DEFAULT_HEADERS },
  maxContentLength: 100000000,
  maxBodyLength: 1000000000,
});

export const authClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: { ...DEFAULT_HEADERS },
});

authClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

authClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = error.response?.data?.message || '';
    const errorStatus = error.response?.status;
    const requestUrl = error.config?.url || '';

    const isAuthRelatedError =
      errorStatus === 401 ||
      errorStatus === 403 ||
      (errorStatus === 400 &&
        (errorMessage.toLowerCase().includes('invalidan token') ||
          errorMessage.toLowerCase().includes('token expired') ||
          errorMessage.toLowerCase().includes('invalid token') ||
          errorMessage.toLowerCase().includes('unauthorized')));

    const isRegistrationRequest = requestUrl.includes('/register');

    if (isAuthRelatedError && !isRegistrationRequest) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);
